import React from 'react';
// import './TermsConditions.css';
import { ProfileBG } from '../../Assests/Assests';

const TermsConditions = () => {
  return (




<div className="shipping-policy-container">
      <div className="image-container">
        {/* <img src={ProfileBG} alt="Shipping Bag" className="bag-image" /> */}
        <div className="image-text">Terms & Conditions</div>
      </div>
      <div className="shipping-text">
        




        
        <p>
          Welcome to Riymay. By accessing and using our website, placing an order, or engaging with our services, you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully before using our site.
        </p>
        <p>
          Riymay, based in India, specializes in premium apparel and leather accessories, and we are committed to providing a seamless shopping experience.
        </p>
        <h3>Order & Payment</h3>
        <p>
          Customers must provide accurate and up-to-date personal information, including billing and shipping details. Payments are processed securely via credit/debit cards, PayPal, UPI, and other available methods. Charges are applied at checkout. We do not offer installment payment options.
        </p>
        <p>
          In case of failed or fraudulent transactions, customers should contact our support team immediately.
        </p>
        <h3>Shipping</h3>
        <p>
        Riymay enterprises take full responsibility for shipping and delivery, ensuring that all orders are securely packed and dispatched via trusted logistics partners. Lost or damaged orders are covered by us until successfully delivered.
        </p>
       
        <h3>Cancellation Policy</h3>
        <p>
          Customers may cancel orders within 24 hours of placement. Cancellations are not permitted after shipping confirmation.
        </p>
        <h3>Intellectual Property</h3>
        <p>
          All website content, including images, branding, and designs, is the exclusive property of Riymay and is protected by copyright laws. Commercial use, reproduction, or resale is strictly prohibited without prior consent.
        </p>
        <h3>Right to Reject Orders</h3>
        <p>
          We reserve the right to reject or cancel orders under certain conditions, such as:
        </p>
        <ul>
          <li>Product unavailability</li>
          <li>Incorrect or unverifiable billing information</li>
          <li>Orders flagged as fraudulent</li>
          <li>Non-receipt of bank transfer payment within 12 days</li>
          <li>Reseller purchase suspicion</li>
          <li>Errors in pricing or product description</li>
          <li>Inability to deliver to the provided address</li>
          <li>Events outside our control</li>
        </ul>
        <h3>Inspection on Delivery</h3>
        <p>
          Upon delivery, customers must inspect the packaging for damage. If the products appear damaged, do not accept the shipment.
        </p>
        <h3>Events Outside Our Control</h3>
        <p>
          Unforeseeable circumstances, such as natural disasters, strikes, or pandemics, may impact our services. In such cases:
        </p>
        <ul>
          <li>We will notify customers as soon as possible.</li>
          <li>Our obligations will be suspended for the event’s duration.</li>
        </ul>
        <h3>Contact Information</h3>
        <p>
          For legal inquiries or further clarifications, please contact: <strong>support@riymay.com</strong>
        </p>
        <p>
          <strong>Effective Date:</strong> February 10, 2025
        </p>
        <p>
          <strong>Copyright Notice:</strong> Copyright © Riymay 2026. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
